var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dashboard-ctn"},[(_vm.url)?_c('iframe',{staticStyle:{"display":"flex"},attrs:{"src":_vm.url,"frameborder":"0","width":"100%","height":"100%","allowtransparency":""},on:{"load":_vm.hideLoading}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }